﻿import {RatingFactorsGateway} from './ratingFactors.gateway';
import {RatingFactorsViewModel} from './ratingFactors.viewmodel';
import * as Repositories from '../../repositories/repositories';
import IAppSettings from "../../../iApp.settings";

export class RatingFactorsController {
    public viewModel: RatingFactorsViewModel;
    public editRatingFactorsForm: ng.IFormController;

    public quoteMessage: string;
    public isLoadingQuote: boolean;

    static $inject = ['$state', '$stateParams', 'ratingFactors.gateway',
        'ValidationService', '$window', 'appSettings'];

    constructor(private $state: ng.ui.IStateService,
                private params: IRatingFactorsEditParams,
                private ratingFactorsGateway: RatingFactorsGateway,
                private validationService: any,
                private $window: ng.IWindowService,
                private appSettings: IAppSettings) {

        this.activate();
    }

    private activate() {
        // this is required in order to set up the validation service to work with the form using "controller as" syntax
        this.validationService = new this.validationService({controllerAs: this, debounce: 600});

        this.loadViewModel();

    }

    private loadViewModel(): ng.IPromise<RatingFactorsViewModel> {
        return this.ratingFactorsGateway.loadRatingFactorsViewModel(this.params.submissionId)
            .then((viewModel: RatingFactorsViewModel) => {
                this.viewModel = viewModel;
                return viewModel;
            });
    }

    public cancel(): void {
        this.$state.go('shellFrame.administrationFrame.search');
    }

    public saveToMarketplace(): void {
        if (this.editRatingFactorsForm.$dirty) {
            this.saveRatingFactors();
        }

        this.$state.go('shellFrame.administrationFrame.search');
    }

    public viewInBackOffice(): void {
        this.$window.location.href = this.appSettings.backOfficeSiteName + "/submission/" + this.viewModel.submission.id + "/policies";
    }

    private saveRatingFactors(): ng.IPromise<void> {
        return this.ratingFactorsGateway.saveRatingFactors(this.viewModel)
            .then(() => {
                this.editRatingFactorsForm.$setPristine();
            });
    }

    public editBillingReferenceNumber(): void {
        this.viewModel.billingReferenceNumberEditable = true;
    }

    public editAutopay(): void {
        this.viewModel.autoPayEditable = true;
    }

    public editSubmissionStatus(): void {
        this.viewModel.submissionStatusEditable = true;
    }
}

interface IRatingFactorsEditParams {
    submissionId: string;
}